<template>
  <div class="first_section">
    <div ref="swiper" class="swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <!-- 使用picture为不同尺寸分配不同大小图片 -->
          <picture>
            <source media="(max-width: 1600px)" srcset="../../assets/home/swiper-banner14401.webp" />
            <source media="(min-width: 1601px)" srcset="../../assets/home/swiper-banner1.webp" />
            <img src="../../assets/home/swiper-banner1.webp" alt="语音压缩算法" />
          </picture>
          <div class="intro-content">
            <h2>语音压缩算法</h2>
            <p class="line"></p>
            <p class="sub">极低256bps码率，使用北斗三号短报文最大可以传输56秒语音</p>
          </div>
        </div>
        <div class="swiper-slide">
          <picture>
            <source media="(max-width: 1600px)" srcset="../../assets/home/swiper-banner14402.webp" />
            <source media="(min-width: 1601px)" srcset="../../assets/home/swiper-banner2.webp" />
            <img src="../../assets/home/swiper-banner2.webp" alt="北斗APP SDK" />
          </picture>
          <div class="intro-content">
            <h2>北斗APP SDK</h2>
            <p class="line"></p>
            <p class="sub">支持安卓、苹果、PC平台，兼容手持、车载、船载各类终端</p>
          </div>
        </div>
        <div class="swiper-slide">
          <picture>
            <source media="(max-width: 1600px)" srcset="../../assets/home/swiper-banner14403.webp" />
            <source media="(min-width: 1601px)" srcset="../../assets/home/swiper-banner3.webp" />
            <img src="../../assets/home/swiper-banner3.webp" alt="短报文接收功能" />
          </picture>
          <div class="intro-content">
            <h2>北斗短报文接收功能</h2>
            <p class="line"></p>
            <p class="sub">无需本地部署北斗指挥机，使用公网接收北斗数据</p>
          </div>
        </div>
      </div>

      <!-- If we need pagination -->
      <div class="swiper-pagination"></div>
    </div>

    <div class="announcement">
      <div class="announcement_content">
        <div class="announce_title">公告中心</div>
        <div class="announce_item_wrapper">
          <router-link class="announce_item first" to="/product/sdk">
            <div class="item">
              <p class="title">企业级-北斗APP开发</p>
              <p class="content">免费北斗APP</p>
            </div>
          </router-link>
          <router-link class="announce_item" to="/product/applyCard">
            <div class="item">
              <p class="title">北斗三号服务情况介绍</p>
              <p class="content">北斗卡申请</p>
            </div>
          </router-link>
          <router-link class="announce_item" to="/solution/custom">
            <div class="item">
              <p class="title">软硬件定制申请</p>
              <p class="content">点击了解</p>
            </div>
          </router-link>
        </div>

        <a class="more_item" href="/pc/bdsystemPro" target="_blank">
          <span>查看更多</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/swiper-bundle.css'

export default {
  mounted() {
    new Swiper(this.$refs.swiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination, Autoplay],

      autoplay: {
        delay: 4000,
      },
      loop: true,

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '"></span>';
        },
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  },
};
</script>



<style lang="scss"scoped>
.first_section {
  position: relative;
  width: 100vw;
  height: 640px;
  .swiper {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 199;
    width: 100vw;
    height: 640px;
    .swiper-slide {
      width: 100vw;
      height: 100%;
      // background-color: #06042d;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        // top: 48px;
        top: 0;
      }
      .intro-content {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        color: #fff;
        h2 {
          margin: 0;
          margin-bottom: 27px;
          font-size: 44px;
          font-weight: 400;
          color: #ffffff;
        }
        .line {
          width: 40px;
          height: 2px;
          background: #eff9fd;
          margin-bottom: 30px;
        }
        .sub {
          font-size: 24px;
          font-weight: 300;
          color: #ffffff;
        }
      }
    }

    .swiper-pagination {
      bottom: 134px !important;
      &::v-deep {
        .swiper-pagination-bullet {
          width: 60px;
          height: 4px;
          background: #ffffff;
          opacity: 0.5;
          border-radius: 2px;
          bottom: 120px;
        }

        .swiper-pagination-bullet-active {
          color: #fff;
          background: #2df7ff;
        }
      }
    }
  }
  .announcement {
    position: absolute;
    bottom: 0;
    left: 0;
    z-index: 199;
    width: 100%;
    height: 110px;
    // background-color: rgba(18, 17, 56, 0.5);
    // background: rgba(255, 255, 255, 0.1);
    .announcement_content {
      width: 1200px;
      height: 110px;
      // line-height: 110px;
      margin: 0 auto;
      color: #fff;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      .announce_title {
        padding-right: 50px;
        font-size: 18px;
        font-weight: bold;
        color: #9fcaff;
        font-style: italic;
      }
      .announce_item_wrapper {
        width: 950px;
        height: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .announce_item {
          width: 33.33%;
          height: 100%;
          border-right: 1px solid rgba(255, 255, 255, 0.2);
          padding-left: 18px;
          position: relative;
          color: #fff;
          .item {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            .title {
              white-space: nowrap;
              font-size: 16px;
            }
            .content {
              text-align: center;
              margin-top: 15px;
              font-size: 14px;
            }
          }
          &:hover {
            background: rgba(255, 255, 255, 0.1);
            transition: 0.3s;
          }
        }
        .first {
          border-left: 1px solid rgba(255, 255, 255, 0.2);
        }
      }
      .more_item {
        line-height: 110px;
        text-decoration: none;
        span {
          font-size: 18px;
          border-bottom: 1px solid #9fcaff;
          padding: 2px;
          font-weight: 400;
          color: #9fcaff;
          font-style: italic;
        }
      }
    }
  }
}

@media (max-width: 1600px) {
  .swiper-slide {
    .intro-content {
      left: 120px;
    }
  }
}
@media (min-width: 1601px) {
  .swiper-slide {
    .intro-content {
      left: 360px;
    }
  }
}
</style>
